import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const FrFlagIcon = ({ size = '36' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none">
      <g clipPath="url(#clip0_476_4029)">
        <rect width="32" height="32" rx="4" fill="white" />
        <path d="M0 32V0H10.4615V32H0Z" fill="#005EC4" />
        <path d="M21.5385 32V0H10.4615V32H21.5385Z" fill="#F1F0F0" />
        <path d="M21.5385 32V0H32V32H21.5385Z" fill="#F90805" />
      </g>
      <defs>
        <clipPath id="clip0_476_4029">
          <rect width="32" height="32" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default React.memo(FrFlagIcon)

FrFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}
